import { render, staticRenderFns } from "./DhlTracking.vue?vue&type=template&id=10a81030&scoped=true&"
import script from "./DhlTracking.vue?vue&type=script&lang=js&"
export * from "./DhlTracking.vue?vue&type=script&lang=js&"
import style0 from "./DhlTracking.vue?vue&type=style&index=0&id=10a81030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a81030",
  null
  
)

export default component.exports